/*
 * © 2025 Fannie Mae. All rights reserved.
 * This software contains confidential information and trade secrets of Fannie Mae.
 * Use, disclosure, or reproduction is prohibited without the prior written consent of Fannie Mae.
 */
import React from 'react';
import WarningAmber from '@mui/icons-material/WarningAmber';
import { REQUEST_STATUSES } from '../../../shared/constants/RequestStatuses';

export default (params) => {
  const statusValue = params.data?.requestStatus || params.data?.statusName || params.data?.internalStatus;
  const hasEscalationFlag = params.data?.isEscalated === true;
  const hasEscalationHistory = Array.isArray(params.data?.requestFeedActivityTrackerDTOList)
    ? params.data.requestFeedActivityTrackerDTOList.some(activity => activity?.isEscalated === true)
    : false;
  const shouldHighlightEscalation =
    statusValue === REQUEST_STATUSES.ESCALATED || hasEscalationFlag || hasEscalationHistory;

  if (shouldHighlightEscalation) {
    return (
      <span className="escalated-indicator" title="Escalated">
        <WarningAmber style={{ color: '#f9a825', width: 18, height: 18 }} />
      </span>
    );
  }
  return null;
};